import React from "react";
import { Image } from "react-bootstrap";
import {
  FiatCurrency,
  TournamentWinner,
} from "@nestcoinco/hyper-api-gateway-api-client";

import "./LatestWinItem.scss";
import { formatCurrency, getTimeAgo } from "../../../utils/helpers";
import useExchangeRatesQuery from "../../../react-query/queries/use-exchange-rates";

function LastWinItem({
  index,
  indexOfItemInView,
  winner,
  selectedCurrency,
}: {
  index: number;
  indexOfItemInView: number;
  winner: TournamentWinner;
  selectedCurrency: FiatCurrency;
}) {
  const isCurrentItem = index === indexOfItemInView;
  const { getExchangeRate } = useExchangeRatesQuery();

  const rewardAmount = winner.tournament?.rewardAmount;
  const exchangeRate = getExchangeRate(selectedCurrency);
  const displayedRewardAmount =
    rewardAmount !== undefined && exchangeRate !== undefined
      ? formatCurrency(rewardAmount * exchangeRate, selectedCurrency, 2)
      : "--";

  return (
    <div
      className="winnersDataContainer"
      style={{
        top: isCurrentItem ? 0 : -100,
        bottom: isCurrentItem ? 0 : undefined,
      }}
    >
      <Image src={winner.avatarUrl} alt="user" className="winnerAvatarImg" />
      <p className="winnerInfo">
        @{winner.username} won{" "}
        {displayedRewardAmount}{" "}
      </p>
      <span className="separatorDot" />
      <p className="winningTimeText">
        {getTimeAgo(winner.tournament?.endDate)}
      </p>
    </div>
  );
}

export default LastWinItem;
